import { getDropdownMetric } from "../actions/mygoal";
import RestService from "./rest.service";

class scalingMaster {
  listEmployee() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/users/profile`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getDataEmployee(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/users/profile/${serial}/edit`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  saveData(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/users/profile/${serial}/save`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new scalingMaster();
